import React from 'react';
import Modal from "react-bootstrap/Modal";
import DOMPurify from "dompurify";
import { displayBase64Pdf } from "../../utils/fileUtils";
import Spinner from "../Spinner/Spinner";

export default function PdfModal(
    {
        displayDocument,
        closeModal,
        title,
        base64,
        fileName,
        loaded,

    }
) {

    // TODO corriger
    return (
        <Modal
            show={ displayDocument }
            size={ 'xl' }
            onHide={ closeModal }
        >
            <Modal.Header>
                <h3  dangerouslySetInnerHTML={ {
                    __html: DOMPurify.sanitize(title)
                } }/>
            </Modal.Header>

            <Modal.Body>

                { base64 ? (
                    <>

                        <object
                            id="affichage-pdf"
                            type="application/pdf"
                            width="100%"
                            height="800"
                            data={ displayBase64Pdf(base64) }
                        />
                    </>
                ) : (

                    <div>
                        { loaded ? <p>Erreur lors du chargement de : ${ title }</p> :
                            <div className="d-flex align-items-center justify-content-center">
                                <Spinner spinClasses={ "fast-spin" }/>
                            </div> }
                    </div>

                ) }

            </Modal.Body>

            <Modal.Footer>

                <div className={ '' }>

                    { loaded && (
                        <a
                            className={ 'btn btn-primary' }
                            href={ displayBase64Pdf(base64) }
                            download={ fileName }
                            dangerouslySetInnerHTML={ {
                                __html: DOMPurify.sanitize(`Télécharger ${ fileName }`)
                            } }/>
                    ) }

                    <button
                        type="button"
                        className="btn btn-secondary ms-3"
                        onClick={ closeModal }
                    >
                        Fermer le document
                    </button>
                </div>

            </Modal.Footer>
        </Modal>
    )
}
